// extracted by mini-css-extract-plugin
export default {"tag":"src-pages-order-components-OrderStatusTag-index-module_tag--J2FXC"};